import type { IconOption } from '@/components/IconPicker'

// Shortlist offered first in the goal form's IconPicker. A goal with no icon renders DEFAULT_GOAL_ICON.
export const DEFAULT_GOAL_ICON = 'target'

export const GOAL_ICON_OPTIONS: IconOption[] = [
  { name: 'target', label: 'Goal' },
  { name: 'shield', label: 'Emergency fund' },
  { name: 'plane', label: 'Travel' },
  { name: 'palmtree', label: 'Holiday' },
  { name: 'car', label: 'Car' },
  { name: 'bike', label: 'Bike' },
  { name: 'home', label: 'Home' },
  { name: 'house-plus', label: 'Renovation' },
  { name: 'graduation-cap', label: 'Education' },
  { name: 'baby', label: 'Child' },
  { name: 'heart', label: 'Wedding' },
  { name: 'gift', label: 'Gifts & festivals' },
  { name: 'laptop', label: 'Gadgets' },
  { name: 'heart-pulse', label: 'Health' },
  { name: 'sun', label: 'Retirement' },
  { name: 'piggy-bank', label: 'Savings' },
]
